import { render, staticRenderFns } from "./MLsportSpecialCart.vue?vue&type=template&id=daa33128&scoped=true"
import script from "./MLsportSpecialCart.vue?vue&type=script&lang=js"
export * from "./MLsportSpecialCart.vue?vue&type=script&lang=js"
import style0 from "./MLsportSpecialCart.vue?vue&type=style&index=0&id=daa33128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa33128",
  null
  
)

export default component.exports